module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAFVBMVEUAAAD///////////////////////9Iz20EAAAABnRSTlMA8OdJO+SJpFFbAAAARElEQVQY02MgCxilQYEykKMG4yQBOWkOEBUsaSAOTD2EIwgkBRkFwBwYQJdB6MHkgNUwYBqAkMHQg3AOmkMRXggmKwQAY6gf7xUre5kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_finance_active.png
// module id = 3Cpj
// module chunks = 9